<template>
<!-- Features -->
<div id="feature-group">
    <div class="feature-group feature-group-1">
        <div v-for="(item, index) in firstGroup" :key="index" :class="['feature-item', classType]">
            <img v-if="item.img" :src="item.img" :alt="item.alt"/>
            <span>{{item.title}}</span>
            <p v-html="item.text"></p>
        </div>
    </div>
    <div class="feature-group feature-group-2">
        <div v-for="(item, index) in secondGroup" :key="index" :class="['feature-item', classType]">
            <img v-if="item.img" :src="item.img" :alt="item.alt"/>
            <span>{{item.title}}</span>
            <p v-html="item.text"></p>
        </div>
    </div>
    <h3 class="center">Extra Features</h3>
    <div class="feature-group feature-group-1">
        <div v-for="(item, index) in thirdGroup" :key="index" :class="['feature-item', classType]">
            <img v-if="item.img" :src="item.img" :alt="item.alt"/>
            <span>{{item.title}}</span>
            <p v-html="item.text"></p>
        </div>
    </div>
</div>
</template>




<script>
export default {
    props: {
        features: {
            type: Array,
            required: true
        },
        classType: {
            type: String,
            default: ''
        }
    },
        computed: {
        firstGroup() {
            return this.features.slice(0, 4);
        },
        secondGroup() {
            return this.features.slice(4, 8);
        },
        thirdGroup() {
            return this.features.slice(8);
        }
    }
}
</script>